// TODO - remove lint disable when editing this file
/* eslint-disable */
import Factory, {
  AFTER_APPEND_BLOCKS_HOOK,
  BEFORE_TO_RAW_HOOK,
  AFTER_FROM_HTML,
  BEFORE_FROM_HTML,
} from './util/Factory'
import AtomicBaseConverter from './converters/AtomicBaseConverter'
import TextConverter from './converters/TextConverter'
import ListConverter from './converters/ListConverter'
import HeaderConverter from './converters/HeaderConverter'
import BlockQuoteConverter from './converters/BlockQuoteConverter'
import TableConverter from './converters/TableConverter'
import OembedConverter from './converters/OembedConverter'
import ReferenceConverter from './converters/ReferenceConverter'
import {
  getCommentAfterToBlocksMiddleware,
  commentBeforeToRawMiddleware,
} from '../DraftEditor/plugins/draft-js-ans-comment-plugin/utils/commentHelper'
import {
  inlineCommentsImportMiddleware,
  inlineCommentsExportMiddleware,
  inlineCommentsConvertSpacesMiddleware,
} from './util/inlineCommentsMiddleware'
import {
  highlightsHydrateMarks,
  highlightsApplyMarks,
} from './util/highlightColorMiddleware'
import { afterAppendBlocksMiddleware as dropCapsAfterAppendBlocksMiddleware } from '~/reactapp/DraftEditor/plugins/draft-js-drop-cap-plugin'
import { annotationApplyMarks, replaceAnnotationsMarks } from './util/annotationsMiddleware.ts'

const converterFactory = new Factory()

converterFactory.addConverter(new AtomicBaseConverter())
converterFactory.addConverter(new TextConverter())
converterFactory.addConverter(new ListConverter())
converterFactory.addConverter(new HeaderConverter())
converterFactory.addConverter(new BlockQuoteConverter())
converterFactory.addConverter(new TableConverter())
converterFactory.addConverter(new OembedConverter())
converterFactory.addConverter(new ReferenceConverter())

// Comments middleware
converterFactory.addMiddleware(
  AFTER_APPEND_BLOCKS_HOOK,
  getCommentAfterToBlocksMiddleware()
)
converterFactory.addMiddleware(BEFORE_TO_RAW_HOOK, commentBeforeToRawMiddleware)

// Highlight load
converterFactory.addMiddleware(BEFORE_FROM_HTML, highlightsHydrateMarks)
converterFactory.addMiddleware(AFTER_FROM_HTML, highlightsApplyMarks)

// Annotations
converterFactory.addMiddleware(BEFORE_FROM_HTML, replaceAnnotationsMarks)
converterFactory.addMiddleware(AFTER_FROM_HTML, annotationApplyMarks)

// Inline comments middleware
converterFactory.addMiddleware(
  BEFORE_FROM_HTML,
  inlineCommentsConvertSpacesMiddleware
)
converterFactory.addMiddleware(AFTER_FROM_HTML, inlineCommentsImportMiddleware)
converterFactory.addMiddleware(
  BEFORE_TO_RAW_HOOK,
  inlineCommentsExportMiddleware
)

// Drop cap middleware
converterFactory.addMiddleware(
  AFTER_APPEND_BLOCKS_HOOK,
  dropCapsAfterAppendBlocksMiddleware
)

export default converterFactory
